import { KodEventLeaderboardDto } from '../pages/driftEvents/kod/KodLeaderboard/KodLeaderboard.types'
import { api, BASE_URL } from './api'
import { createAuthenticatedEventSource } from './authenticatedEventSource'

export class EventService {

	static getInviteSSE(token: string): EventSource {
		return createAuthenticatedEventSource(`${BASE_URL}/events/sse/stream?token=${token}`)
	}

	static async getLeaderboard(): Promise<KodEventLeaderboardDto> {
		return api.get<KodEventLeaderboardDto>('/events/kod/leaderboard')
			.then(response => response.data)
	}

	static async setKodContinued(): Promise<void> {
		api.post<void>('/events/kod/continue')
	}

}
